export default {
  async addUser(_, userData) {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/lead-history/users/add-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });
      console.log("the response:", response);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to add user");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error adding user:", error);
      throw error;
    }
  },

  async loginUser(_, userData) {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/lead-history/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Login failed");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  },

  async verifyOtp(_, data) {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/lead-history/users/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json(); 
      return responseData;
    } catch (error) {
      console.error("Error in forgotUser action:", error);
      throw error;
    }
  },

  async setNewPassword(_, data) {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/lead-history/users/new-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json(); 
      return responseData;
    } catch (error) {
      console.error("Error in forgotUser action:", error);
      throw error;
    }
  },

  async forgotPassword(_, data) {
    try {
      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/lead-history/users/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      console.log("🚀 ~ forgotPassword ~ response:", response)

      const responseData = await response.json(); 
      return responseData;
    } catch (error) {
      console.error("Error in forgotUser action:", error);
      throw error;
    }
  },
};
